import UploadNewBookPage from './UploadNewBookPage'
export default UploadNewBookPage;